// extracted by mini-css-extract-plugin
export var chip = "_g5-0";
export var filterDropdown = "_g5-5";
export var filterItem = "_g5-6";
export var icon = "_g5-1";
export var removeButton = "_g5-3";
export var removeIcon = "_g5-4";
export var separator = "_g5-2";